import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const IOS_URL = 'https://apps.apple.com/app/pholtr/id6753979622';
const ANDROID_URL = 'https://play.google.com/store/apps/details?id=nu.hibou.prodshot';
const TRACK_URL = 'https://us-central1-prodshot-18854.cloudfunctions.net/trackReferralClick';

export default function Referral() {
  const { code } = useParams();

  useEffect(() => {
    if (!code) return;

    const storeUrl = /Android/i.test(navigator.userAgent) ? ANDROID_URL : IOS_URL;

    fetch(TRACK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code }),
    })
      .catch(() => {})
      .finally(() => {
        window.location.replace(storeUrl);
      });
  }, [code]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      fontFamily: 'sans-serif',
      color: '#333',
    }}>
      <h1 style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>pholtr</h1>
      <p style={{ color: '#666' }}>Opening the App Store…</p>
    </div>
  );
}
